import { useState } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { addSkill, removeSkill } from '../store/skillSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';

const Skill = () => {
  const [name, setName] = useState('');
  const [level, setLevel] = useState<'Starter' | 'Good' | 'Experience' | 'Professional'>('Starter');
  const dispatch = useDispatch();
  const skills = useSelector((state: RootState) => state.skillSlice);
  
    const handleDelete = () => {
      dispatch(removeSkill(name));
    };

  const handleAdd = () => {
    if (!name) return;

    let newLevel = 1
    switch(level) {
        case 'Starter':
            newLevel = 1
            break;
        case 'Good':
            newLevel = 2
            break;
        case 'Experience':
            newLevel = 3
            break;
        case 'Professional':
            newLevel = 4
            break;
    }

    dispatch(addSkill({ id: name, name, level: newLevel }));
    setName('');
    setLevel('Starter');
  };

  return (
    <Row className="mb-3">
      <Col>
       <Form.Control className='mb-2' placeholder="Skill name" value={name} onChange={(e) => setName(e.target.value)} />
        <Form.Select value={level} onChange={(e) => setLevel(e.target.value as any)}>
          <option>Starter</option>
          <option>Good</option>
          <option>Experience</option>
          <option>Professional</option>
        </Form.Select>

         <Row>
            <Col className="d-flex justify-content-end mt-2">
                <Button style={{marginRight: '4px'}} onClick={handleAdd}>Add</Button>
                {skills.length > 0 && <Button onClick={handleDelete}>Delete</Button>}
            </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Skill;
